import { useBoardsQuery } from '@modules/board/hooks/useBoardsQuery';
import { List, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import { SkeletonConversationItem } from 'src/components/skeleton';
import {
  NavAccordionDetails,
  NavAccordionLabel,
  NavAccordionSummary,
} from 'src/features/Navbar/NavAccordion/NavAccordion';
import { NavAccordionPersisted } from 'src/features/Navbar/NavAccordionPersisted';
import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { useLocales } from 'src/locales';
import { useCreateBoardDialog } from 'src/sections/@dashboard/board/shared/CreateBoardDialog';
import { UIFeature } from 'src/state/ui/types';
import { MoreNavItensButton } from '../../shared/MoreNavItensButton';
import { NavRootList } from '../../shared/styles';
import { BoardNavItem } from './BoardNavItem';
import { useBoardNavMoreDrawer } from './BoardNavMoreDrawer';

export const BoardsNav = () => {
  const { showCreateBoardDialog } = useCreateBoardDialog();
  const { showBoardNavMoreDrawer } = useBoardNavMoreDrawer();
  const { boards, isBoardsLoading } = useBoardsQuery();
  const { translate } = useLocales();

  return (
    <NavAccordionPersisted feature={UIFeature.boards}>
      <NavAccordionSummary className="board">
        <NavAccordionLabel>
          <Iconify className="navIcon" icon="tabler:layout-kanban-filled" />
          <Typography variant="subtitle2">
            {translate('header.nav_vertical.board_tab.boards')}
          </Typography>
        </NavAccordionLabel>
        <NavActionButton icon="tabler:plus" onClick={showCreateBoardDialog} />
      </NavAccordionSummary>
      <NavAccordionDetails>
        {isBoardsLoading && (
          <List disablePadding>
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
            <SkeletonConversationItem />
          </List>
        )}
        {!isBoardsLoading && boards && (
          <NavRootList disablePadding sx={{ '&.MuiList-root': { gap: 0 } }}>
            {boards.map((board) => (
              <BoardNavItem key={board._id} board={board} />
            ))}

            {boards.length > 8 && (
              <MoreNavItensButton onClick={showBoardNavMoreDrawer} />
            )}
          </NavRootList>
        )}
      </NavAccordionDetails>
    </NavAccordionPersisted>
  );
};
